import React, { useState, useContext, useEffect } from 'react'
import { Form, Switch, Divider } from 'antd'
import { CreateMemberLyfeContext } from '../../../../../../..'
// import TooltipInfo from '../../../../../../../../CreateEventV2/TooltipInfo'
import HourForm from '../HourForm'
import './index.styl'

const { Item, List } = Form

const Thursday = ({ currentPageDetails }) => {
  const { form } = useContext(CreateMemberLyfeContext)

  const [thursdaySwitch, setThursdaySwitch] = useState(false)
  const [hours, setHours] = useState(form.getFieldValue('thursday') || [])
  // const mobile = window.innerWidth <= 730
  // const tooltipTitle = `Charity Raffles are limited to $30,000 in total ticket sales and $100 max price per ticket

  // Ticket Lyfe charges for Charity Raffle Tickets are $1 for Raffles priced up to $50 and $2 for higher priced Raffle Tickets

  // Do not pick Charity Raffles if you are doing a regular event with Random Draw Prizes--Because you can do a Random Draw on ANY Ticket Lyfe Event, the Charity Raffle limits above will not apply, and Ticket Lyfe treat your event as an ordinary Ticketed Event`

  // const additionalTooltip = (
  //  <TooltipInfo
  //    className='tooltipTitle'
  //    text={mobile ? '' : 'Additional info'}
  //    info={tooltipTitle}
  //  />
  // )

  useEffect(() => {
    if (!!currentPageDetails?.workingHours?.thursday?.length) {
      setThursdaySwitch(true)
      setHours(currentPageDetails.workingHours.thursday)
    }
  }, [currentPageDetails])

  useEffect(() => {
    if (!hours.length) {
      setThursdaySwitch(false)
      form.setFieldsValue({
        thursdaySwitch: false,
      })
    }
  }, [hours, form])

  const handleSwitchChange = checked => {
    setThursdaySwitch(checked)
    if (checked && !hours.length) {
      const newHour = [{}]
      setHours(newHour)
      form.setFieldsValue({
        thursday: newHour,
      })
    }
  }

  const getThursdayData = idx => {
    return hours[idx]
  }

  return (
    <div className='mondayWrapper'>
      <div className={thursdaySwitch ? 'betweenWraper active' : 'betweenWraper'}>
        <div className='radioWrapper'>
          <Item style={{ marginBottom: 0 }} name='thursdaySwitch' valuePropName='checked' className='monday'>
            <Switch onChange={handleSwitchChange} />
          </Item>
          <div className='text'>Thursday</div>
        </div>
        {/* <div className='tooltipWrapper'>{additionalTooltip}</div> */}
      </div>
      {thursdaySwitch && (
        <List name='thursday'>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }) => (
                <HourForm
                  fieldName='thursday'
                  categoryData={getThursdayData(fieldKey)}
                  form={form}
                  key={key}
                  name={name}
                  fieldKey={fieldKey}
                  onRemove={index => {
                    remove(index)
                    const updatedHours = form.getFieldValue('thursday')
                    setHours(updatedHours)
                    if (updatedHours.length === 0) {
                      form.setFieldsValue({
                        thursdaySwitch: false,
                      })
                    }
                  }}
                  {...restField}
                />
              ))}
              <div
                id='addCategory' className='addCategoryBtn' onClick={() => {
                  add()
                  const updatedHours = form.getFieldValue('thursday')
                  setHours(updatedHours)
                }}
              >Add Another Activity
              </div>
            </>
          )}
        </List>
      )}
      <Divider />
    </div>
  )
}

export default Thursday
